export enum DistributorsDataTypes {
    SEARCH = "search",
    EXTENDED = "extended"
}

export const distributorsDataTypeEnumValues = Object.values(DistributorsDataTypes);
